//Necesario para permitir redireccionamiento dinámico
import { createBrowserHistory } from 'history';
export default createBrowserHistory();